/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_VolumeInputs */

const th_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระดับเสียง`)
};

const en_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const ja_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音量`)
};

const zh_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音量`)
};

const es_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen`)
};

const pt_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const id_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const fr_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const tl_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lakas`)
};

const vi_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Âm lượng`)
};

const ko_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`음량`)
};

const de_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautstärke`)
};

const ru_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Громкость`)
};

const tr_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ses düzeyi`)
};

const it_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const pl_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Głośność`)
};

const uk_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гучність`)
};

const hi_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवाज़`)
};

const ar_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستوى الصوت`)
};

const ms_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelantangan`)
};

const bn_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শব্দমাত্রা`)
};

const zh_tw2_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音量`)
};

const zh_hk2_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音量`)
};

const ur_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آواز`)
};

const fa_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلندی صدا`)
};

const sw_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauti`)
};

const nl_video_volume = /** @type {(inputs: Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Video_VolumeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_volume = /** @type {((inputs?: Video_VolumeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_VolumeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_volume(inputs)
	if (locale === "ja") return ja_video_volume(inputs)
	if (locale === "zh") return zh_video_volume(inputs)
	if (locale === "es") return es_video_volume(inputs)
	if (locale === "pt") return pt_video_volume(inputs)
	if (locale === "id") return id_video_volume(inputs)
	if (locale === "fr") return fr_video_volume(inputs)
	if (locale === "tl") return tl_video_volume(inputs)
	if (locale === "vi") return vi_video_volume(inputs)
	if (locale === "ko") return ko_video_volume(inputs)
	if (locale === "de") return de_video_volume(inputs)
	if (locale === "ru") return ru_video_volume(inputs)
	if (locale === "tr") return tr_video_volume(inputs)
	if (locale === "it") return it_video_volume(inputs)
	if (locale === "pl") return pl_video_volume(inputs)
	if (locale === "uk") return uk_video_volume(inputs)
	if (locale === "hi") return hi_video_volume(inputs)
	if (locale === "ar") return ar_video_volume(inputs)
	if (locale === "ms") return ms_video_volume(inputs)
	if (locale === "bn") return bn_video_volume(inputs)
	if (locale === "zh-TW") return zh_tw2_video_volume(inputs)
	if (locale === "zh-HK") return zh_hk2_video_volume(inputs)
	if (locale === "ur") return ur_video_volume(inputs)
	if (locale === "fa") return fa_video_volume(inputs)
	if (locale === "sw") return sw_video_volume(inputs)
	if (locale === "nl") return nl_video_volume(inputs)
	return en_video_volume(inputs)
});